import { UNRESOLVED_LOAN_ACTIVATION_EXISTS } from '../../creditAvailability';

export { UNRESOLVED_LOAN_ACTIVATION_EXISTS };
export const LOAN_ACTIVATION_FAILED_REVIEW_REQUIRED = 'LOAN_ACTIVATION_FAILED_REVIEW_REQUIRED';
export const LOAN_ACTIVATION_PENDING = 'LOAN_ACTIVATION_PENDING';
export const LOAN_ORIGINATION_IN_PROGRESS = 'LOAN_ORIGINATION_IN_PROGRESS';

const GENERIC_CONFIRM_ERROR = {
  icon: 'error',
  title: 'Error',
  text: 'Hubo un error al confirmar la operación.',
};

const ACTIVATION_FAILED_ALERT = {
  icon: 'warning',
  title: 'Venta registrada - activación pendiente de revisión',
  text: 'La venta fue registrada correctamente, pero no se pudo completar la activación del crédito. No vuelvas a confirmar ni generes una nueva venta. La operación quedó registrada para revisión.',
  confirmButtonText: 'Entendido',
  showCancelButton: false,
  showDenyButton: false,
  allowOutsideClick: false,
};

const UNRESOLVED_ACTIVATION_ALERT = {
  icon: 'warning',
  title: 'Operación pendiente',
  text: 'Ya existe una venta registrada pendiente de activación. No es posible confirmar una nueva venta hasta que la operación anterior sea resuelta.',
  confirmButtonText: 'Entendido',
  showCancelButton: false,
  showDenyButton: false,
  allowOutsideClick: false,
};

const ORIGINATION_IN_PROGRESS_ALERT = {
  icon: 'warning',
  title: 'Operación en proceso',
  text: 'Hay otra operación de crédito procesándose para esta persona. Intentá nuevamente en unos instantes.',
  confirmButtonText: 'Entendido',
  showCancelButton: false,
  showDenyButton: false,
  allowOutsideClick: false,
};

const readBackendCode = (error) => {
  const code = error?.response?.data?.code;
  return typeof code === 'string' ? code : '';
};

const exitAfterRegisteredSale = (onCloseToSales) => {
  if (typeof onCloseToSales === 'function') {
    onCloseToSales();
    return;
  }

  window.location.href = '/';
};

const SALES_BLOCKING_CONFIRM_CODES = new Set([
  LOAN_ACTIVATION_FAILED_REVIEW_REQUIRED,
  LOAN_ACTIVATION_PENDING,
  UNRESOLVED_LOAN_ACTIVATION_EXISTS,
]);

export const blocksFurtherCreditechSales = (code) =>
  typeof code === 'string' && SALES_BLOCKING_CONFIRM_CODES.has(code);

export const classifyPurchaseConfirmError = (error) => {
  switch (readBackendCode(error)) {
    case LOAN_ACTIVATION_FAILED_REVIEW_REQUIRED:
      return 'activation_failed';
    case LOAN_ACTIVATION_PENDING:
      return 'activation_pending';
    case UNRESOLVED_LOAN_ACTIVATION_EXISTS:
      return 'unresolved_activation';
    case LOAN_ORIGINATION_IN_PROGRESS:
      return 'origination_in_progress';
    default:
      return 'generic';
  }
};

export const presentPurchaseConfirmError = async (error, { swal, onCloseToSales } = {}) => {
  const kind = classifyPurchaseConfirmError(error);

  if (kind === 'activation_failed') {
    await swal.fire(ACTIVATION_FAILED_ALERT);
    exitAfterRegisteredSale(onCloseToSales);
    return kind;
  }

  if (kind === 'activation_pending') {
    return kind;
  }

  if (kind === 'unresolved_activation') {
    await swal.fire(UNRESOLVED_ACTIVATION_ALERT);
    return kind;
  }

  if (kind === 'origination_in_progress') {
    await swal.fire(ORIGINATION_IN_PROGRESS_ALERT);
    return kind;
  }

  await swal.fire(GENERIC_CONFIRM_ERROR);
  return kind;
};
